import lpApp from '../lp_app';
import { lpIdGetPure } from '../../logic/global_getter';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/utils.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpUtils {
  addModalClassToBody() {
    document.body.classList.add('lp-mdl');
    // if(lpApp.env.is_mobile)
    //     document.querySelector(".page-wrap").style.display = "none";
  }

  removeModalClassToBody() {
    document.body.classList.remove('lp-mdl');
    // if(lpApp.env.is_mobile)
    //     document.querySelector(".page-wrap").style.display = "";
  }

  /**
     * flatten an object to a simple direct flat
     * @param {Object} dict
     * @param {Object} output
     * @param {String} prefix
     */
  flattenDict(dict = {}, output = {}, prefix = '') {
    const flattenOutput = output;
    if (typeof dict !== 'object') return flattenOutput;
    // the dict is an object
    const keys = Object.keys(dict);
    keys.forEach((idx) => {
      if (typeof dict[idx] === 'object') {
        this.flattenDict(dict[idx], flattenOutput, `${prefix + idx}__`);
      } else {
        flattenOutput[prefix + idx] = dict[idx];
      }
    });
    return flattenOutput;
  }

  getEditedVariables() {
    const variableActions = {};
    const keys = Object.keys(lpApp.indexes.variables.variables);
    keys.forEach((idx) => {
      if (lpApp.indexes.variables.variables[idx].value !== '') variableActions[idx] = true;
    });
    // updating if there is a variable or an option in there
    const { vF } = lpApp.getState().loadedOvc;
    const vFKeys = (typeof vF === 'undefined') ? [] : Object.keys(vF);
    vFKeys.forEach((idx) => {
      if (vF[idx] !== '')variableActions[idx] = true;
    });
    if (typeof variableActions === 'undefined') return 0;
    return Object.keys(variableActions).length;
  }


  getEditedOptions() {
    const OptionActions = {};
    const { oF, cF } = lpApp.getState().loadedOvc;
    const oFKeys = (typeof oF === 'undefined') ? [] : Object.keys(oF);
    const cFKeys = (typeof cF === 'undefined') ? [] : Object.keys(cF);
    const optionsKeys = Object.keys(lpApp.indexes.options.options);

    optionsKeys.forEach((idx) => {
      if (lpApp.indexes.options[idx]) OptionActions[idx] = true;
    });
    oFKeys.forEach((idx) => {
      if ((oF[idx]) && lpApp.references.getOption(lpIdGetPure(idx)) && (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'radio'))OptionActions[idx] = true;
    });
    cFKeys.forEach((idx) => {
      if ((cF[idx]) && (lpApp.references.getOption(lpIdGetPure(idx)).meta.type === 'checkbox'))OptionActions[idx] = true;
    });
    if (typeof OptionActions === 'undefined') return 0;
    return Object.keys(OptionActions).length;
  }

  getAllChildren(id, r = []) {
    const pureId = lpIdGetPure(id);

    if (!lpApp.references.options[pureId]) {
      return r;
    }

    const now = lpApp.references.options[pureId].children;
    now.forEach((idx) => {
      r.push(idx);
      this.getAllChildren(idx, r);
    }, this);
    return r;
  }

  getAllVariableChildren(ids = []) {
    const result = [];
    ids.forEach((idx) => {
      lpApp.references.options[idx].variables.map(jdx => result.push(jdx));
    });
    return result;
  }
}

export default LpUtils;



// WEBPACK FOOTER //
// ./src/app/ops/utils.js